/* global axios */
import ApiClient from './ApiClient';

class WhatsappCallsAPI extends ApiClient {
  constructor() {
    super('conversations', { accountScoped: true });
  }

  create(conversationId, { sdp }) {
    return axios.post(`${this.url}/${conversationId}/calls`, { sdp });
  }

  show(conversationId, callId) {
    return axios.get(`${this.url}/${conversationId}/calls/${callId}`);
  }

  accept(conversationId, callId, { sdp }) {
    return axios.post(`${this.url}/${conversationId}/calls/${callId}/accept`, {
      sdp,
    });
  }

  reject(conversationId, callId) {
    return axios.post(`${this.url}/${conversationId}/calls/${callId}/reject`);
  }

  terminate(conversationId, callId) {
    return axios.post(
      `${this.url}/${conversationId}/calls/${callId}/terminate`
    );
  }

  permissionRequest(conversationId) {
    return axios.post(`${this.url}/${conversationId}/calls/permission_request`);
  }
}

export default new WhatsappCallsAPI();
